import { css } from 'linaria';
import { media } from '../../../../../media';

export const CardDescription = css`
	display: block;
	margin-top: 8px;

	${media.tablet} {
		max-width: 240px;
	}
	${media.mobile} {
		max-width: 223px;
	}
`;
